import {BusinessType} from "@/store/api/businessTypeApi";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface BusinessTypeState {
    businessTypes: BusinessType[];
}

const initialState: BusinessTypeState = {
    businessTypes: [],
}

const businessTypeSlice = createSlice({
    name: "businessTypes",
    initialState,
    reducers: {
        setBusinessTypes: (state, action: PayloadAction<BusinessType[]>) => {
            state.businessTypes = action.payload;
        },
        clearBusinessTypes: (state) => {
            state.businessTypes = [];
        }
    }
})


export const { setBusinessTypes, clearBusinessTypes } = businessTypeSlice.actions;
export default businessTypeSlice.reducer;
